import { DatePicker as TrussDatePicker } from "@trussworks/react-uswds";
import cn from "classnames";

// types
import { DatePickerProps as TrussDatePickerProps } from "@trussworks/react-uswds/lib/components/forms/DatePicker/DatePicker";

// styles
import styles from "./DatePicker.module.scss";

type DatePickerProps = {
  label?: string;
  rootClassName?: string;
  pickerClassName?: string;
} & TrussDatePickerProps;

export default function DatePicker(props: DatePickerProps) {
  const { label, rootClassName, pickerClassName, ...rest } = props;

  const rootClasses = cn(styles["picker-root"], {
    [rootClassName!]: rootClassName,
  });

  const inputClasses = cn(styles["picker-wrapper"], {
    [pickerClassName!]: pickerClassName,
  });

  return (
    <div className={rootClasses}>
      {label && <label htmlFor={props.id}>{label}</label>}
      <div className={inputClasses}>
        <TrussDatePicker {...rest} />
      </div>
    </div>
  );
}
